export default __webpack_public_path__ + "RenewableDieselDefaultPin.png";